// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"66":"5455dbb8","206":"f4116ee2","472":"b6cd6577","715":"abb772cb","869":"54f6ecf7","880":"f959ef21"}[chunkId] + ".css";
};